export const offlineErrorMessage = "Network error: Failed to fetch";
